module.exports = __webpack_public_path__ + "static/media/infoJumbo2.9d8a9c50.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/loewer/images/infoJumbo2.png
// module id = 520
// module chunks = 0